
const it = {
    auth: {

        userOrPasswordWrong: 'Utenza o password non corretti',
        wrongMobileNumber: 'Numero di telefono non valido/ troppo corto',
        tooManyRequests:
            'Troppi tentativi di invio, verifica la mail ed eventualmente attendi 1 minuto prima di riprovare',
        popupBlocked: 'Popup bloccati, abilita i popup per continuare',
        popupclosedbyuser: "Popup chiusi dall'utente, riprova",
        appName: 'Preventivi',
        companyName: 'Arcosistemi Srl',
        poweredBy: 'Powered by',
        slogan: 'Rendi semplice la gestione della tua azienda',
        startAdventure: 'Arcosistemi progetta e realizza sistemi oscuranti su misura.',
        startAdventure2: "Sistema di gestione dei preventivi e ordini",
        welcomeTo: 'Benvenuto in ',

        welcomeApp: 'Benvenuto nell\'applicazione di gestione dei preventivi e ordini',
        signIn: 'Accedi',
        signInDescription: 'Accedi per continuare',
        signup: "Registrati con l'indirizzo email",
        signinMsg: "Accedi con l'indirizzo email",
        googleSignup: 'Registrati con Google',
        googleSignin: 'Accedi con Google',
        firstname: 'Nome',
        lastname: 'Cognome',
        username: 'Email',
        email: 'Email',
        password: 'Password',

        register: 'Registrati',
        signin: 'Accedi',

        agree: 'Accetta',
        newOnApp: 'Nuovo su Billu?',
        createAccount: 'Crea un account',
        termsConditions: 'Termini e Condizioni',
        alreadyHaveAccount: 'Hai già un account?',

        enterCredentials: 'Inserischi le credenziali',
        checkEmail: 'Controlla la tua email',
        sentEmail: "Ti abbiamo inviato un'email con le istruzioni per procedere",
        sendEmail: 'Invia email',
        notReceivedEmail:
            "Non hai ricevuto l'email? Premi il pulsante qui sotto per inviarla di nuovo (controlla nello spam eventualmente - attendi almeno 1 minuto prima di procedere)",
        loginHello: 'Ciao, bentornato!',
        rememberMe: 'Ricordami',
        forgotPassword: 'Passord dimenticata?',
        dontHaveAccount: "Non hai un'utenza?",
        forgotPwdTitle: 'Reset Password',
        forgotPwdMsg:
            "Inserisci l'indirizzo email associato al tuo account e ti invieremo le istruzioni per reimpostare la password",
        logout: 'Esci',
        //userOrPasswordWrong: 'Email o password non corretti',
        tooManyTrials:
            'Troppi tentativi di invio, verifica la mail (anche nella cartella spam)  ed eventualmente attendi 1 minuto prima di riprovare',
        phoneNumTooShort: 'Numero di telefono troppo corto',
        resetPwdSent: 'Email per reimpostare la password inviata',
        errGoogleNotAuth: "Google non ha autorizzato l'accesso",
        errSignUp: 'Registrazione non consentita',
        errSignIn: 'Accesso non consentito',
        errPasswordNotValid: 'Password non corretta',
        errChangePwd: 'Cambio password non consentito',
        errCreateUser: 'Creazione utente non consentita',
        errSetNewPwd: 'Impostazione nuova password non consentita',
        errAuthProcess: 'Errore nel processo di Autenticazione',
        errAccountExists:
            "L'account {account} utilizza un provider di autenticazione differente. Riprova con il provider",
        firebaseAppCheckTokenInvalid: "Il token di verifica dell'App Check non è valido",
        appAccess: {
            MICROSOFT: 'Accedi con Microsoft',
            GOOGLE: 'Accedi con Google',
        },
        registerPolicyAccept: 'Accetto',
        registerPolicyTerms: 'privacy policy & terms',
        back2Website: 'Torna al sito web',

        backToLogin: 'Torna al login',
        errorRetrievingUserData: 'Errore nel recupero dei dati utente',
        verifyTitle: 'Verifica email',
        verifyDescription: 'Controlla la tua email e clicca sul link di verifica per completare la registrazione',
        verifyWait: 'Attenzione, attendi 1 minuto prima di richiedere una nuova email',
        verifyEmail: 'Verifica email',
        verifyAlreadyVerified: 'Hai già verificato l\'account?',
        verifyBackToLogin: 'Torna al login',
        changePassword: 'Cambia password',
        changePasswordHere: 'Per cambiare la tua password procedi qui',
        currentPassword: 'Password attuale',
        newPassword: 'Nuova password',
        confirmNewPassword: 'Conferma nuova password',
        passwordDifferent: 'Le password non corrispondono',
        logoutView: {
            title: 'Stai uscendo dall\'applicazione',
            message: 'Stiamo disconnettendo il tuo account, attendi un attimo',
            button: 'Esci',
        }



    },
}

export default it
